import * as img from './assets/images';
import { JumbotronTypes, LocationTypes } from '@codeparva/gatsby-theme-layout-components';
import { exampleLocations } from '../locationMap/config';
import { FaMapMarker } from '@react-icons/all-files/fa/FaMapMarker';

export const media: JumbotronTypes.TMedia = {
  video: {
    // src: 'https://syrasoft-tenant-facing-websites.s3.amazonaws.com/Inez_Storage/showing+all+enclosed+RV+units.mp4',
    src: '',
    alt: 'video',
  },
  imagesSrc: [
    {
      src: '',
      alt: '',
    },
  ],
};

export const textOverlay: JumbotronTypes.TTextOverlay = {
  title: `Find Your Perfect Storage Solution`,
  subTitle: `Pick Your Convenient Location, Pick Your Convenient Location,
, Pick Your Convenient Location.`,
};

// export const textOverlay: JumbotronTypes.TextOverlay = {
//   title: `Best Storage Space with Drive-up Access`,
//   subTitle: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. `,
// };

export const buttonText: JumbotronTypes.TButtonText = [
  {
    type: 'outlined',
    label: 'View Rates',
    link: 'view-rates',
  },
  {
    type: 'custom',
    label: 'Reserve',
    link: 'reserve',
  },
  {
    type: 'primary',
    label: 'Rent',
    link: 'rent',
  },
];

export const daywiseHours: JumbotronTypes.TDaywiseHours = [
  {
    label: 'Sun - Fri',
    data: '08:00 AM - 05:00 PM',
  },
  {
    label: 'Sun ',
    data: '08:00 AM - 05:00 PM',
  },
];

export const accordion: JumbotronTypes.IAccordion = {
  closeIcon: {
    iconClassName: 'FaRegTimesCircle',
    size: '24',
    color: 'primary',
  },
  openIcon: {
    iconClassName: 'FaPlusCircle',
    size: '24',
    color: 'primary',
  },
  title: 'Facility Hours',
};

// export const facilityHours: JumbotronTypes.TFacilityHours = {
//   accordion: accordion,
//   hours: [
//     {
//       icon: {
//         iconClassName: 'FaClock',
//         size: '46',
//         color: 'secondary',
//       },
//       text: 'Facility Hours',
//       hour: daywiseHours,
//     },
//     {
//       icon: {
//         iconClassName: 'FaBuilding',
//         size: '46',
//         color: 'secondary',
//       },
//       text: 'Gate Access Hours',
//       hour: daywiseHours,
//     },
//   ],
// };

export const priceSection1: JumbotronTypes.TPriceSection = {
  icon: {
    iconClassName: 'FaFileInvoiceDollar',
    size: '',
    color: 'primary',
  },
  text: 'Price starting at',
  price: {
    icon: {
      iconClassName: 'FaDollarSign',
      size: '',
      color: 'accent',
    },
    unitStartingPrice: 56,
  },
};

export const priceSection2: JumbotronTypes.TPriceSection = {
  icon: {
    iconClassName: 'FaFileInvoiceDollar',
    size: '',
    color: 'primary',
  },
  text: 'Price starting at',
  price: {
    icon: {
      iconClassName: 'FaDollarSign',
      size: '',
      color: 'accent',
    },
    unitStartingPrice: 57,
  },
};

export const priceSection3: JumbotronTypes.TPriceSection = {
  icon: {
    iconClassName: 'FaFileInvoiceDollar',
    size: '',
    color: 'accent',
  },
  text: 'Price starting at',
  price: {
    icon: {
      iconClassName: 'FaDollarSign',
      size: '',
      color: 'accent',
    },
    unitStartingPrice: 58,
  },
};

export const priceSection4: JumbotronTypes.TPriceSection = {
  icon: {
    iconClassName: 'FaFileInvoiceDollar',
    size: '',
    color: 'accent',
  },
  text: 'Price starting at',
  price: {
    icon: {
      iconClassName: 'FaDollarSign',
      size: '',
      color: 'accent',
    },
    unitStartingPrice: 59,
  },
};

export const contactNumber: JumbotronTypes.TContactNumber = [
  {
    icon: {
      iconClassName: 'FaPhoneAlt',
      size: '',
      color: 'primary',
    },
    label: 'Phone Number',
    data: 1234567890,
    link: 'tel:1234567890',
  },
];

export const address1: JumbotronTypes.TAddress = [
  {
    icon: {
      iconClassName: '',
      size: '',
      color: '',
    },
    label: '',
    data: '',
    link: '',
  },
];

export const address2: JumbotronTypes.TAddress = [
  {
    icon: {
      iconClassName: 'FaMapMarkerAlt',
      size: '',
      color: 'primary',
    },
    label: '',
    data: '',
    link: '',
  },
];
export const address3: JumbotronTypes.TAddress = [
  {
    icon: {
      iconClassName: 'FaMapMarkerAlt',
      size: '',
      color: 'primary',
    },
    label: '',
    data: '',
    link: '',
  },
];

export const facilityGateHours: JumbotronTypes.IFacilityHrs = {
  show: false,
  locations: exampleLocations,
  isHoursForAllLocationsSame: true,
  locationType: 'multi',
};

export const reviewRating: LocationTypes.IRating = {
  rating: '3.2',
  totalReviews: 7,
  maxRating: 5,
  size: 16,
};

export const reviewLink: JumbotronTypes.TReviewLink = {
  text: 'Check Reviews',
  link: '',
  color: 'primary',
};

export const contactDetails: JumbotronTypes.TContactDetails = [
  {
    facilityName: '',
    locationName: '',
    address: address1,
    reviewRating,
    reviewLink,
    contactNumber,
    facilityHours: {
      officeHrs: {
        weekdays: {
          open: '0900',
          close: '1830',
        },
        weekends: {
          open: '0900',
          close: '1200',
        },
      },
      gateHrs: {
        weekdays: {
          open: '0930',
          close: '2000',
        },
        weekends: {
          open: '0900',
          close: '1200',
        },
      },
    },
    priceSection: priceSection1,
    buttonText,
    facilityGateHours,
  },
  // {
  //   facilityName: 'Storage Plus',
  //   locationName: 'Storage Plus of Baldwin County - Barnwell',
  //   address: address2,
  //   contactNumber: contactNumber,
  //   reviewRating: reviewRating,
  //   reviewLink: reviewLink,
  //   facilityHours: {
  //     officeHrs: {
  //       weekdays: {
  //         open: '0900',
  //         close: '1830',
  //       },
  //       weekends: {
  //         open: '0900',
  //         close: '1200',
  //       },
  //     },
  //     gateHrs: {
  //       weekdays: {
  //         open: '0930',
  //         close: '2000',
  //       },
  //       weekends: {
  //         open: '0900',
  //         close: '1200',
  //       },
  //     },
  //   },
  //   priceSection: priceSection2,
  //   buttonText: buttonText,
  //   facilityGateHours: facilityGateHours,
  // },
  // {
  //   facilityName: 'Storage Plus',
  //   locationName: 'Storage Plus of Baldwin County - Silverhill',
  //   address: address3,
  //   priceSection: priceSection3,
  //   contactNumber: contactNumber,
  //   reviewRating: reviewRating,
  //   reviewLink: reviewLink,
  //   facilityHours: {
  //     officeHrs: {
  //       weekdays: {
  //         open: '0900',
  //         close: '1830',
  //       },
  //       weekends: {
  //         open: '0900',
  //         close: '1200',
  //       },
  //     },
  //     gateHrs: {
  //       weekdays: {
  //         open: '0930',
  //         close: '2000',
  //       },
  //       weekends: {
  //         open: '0900',
  //         close: '1200',
  //       },
  //     },
  //   },
  //   buttonText: buttonText,
  //   facilityGateHours: facilityGateHours,
  // },
  // {
  //   facilityName: 'Storage Plus',
  //   locationName: 'Storage Plus of Baldwin County - Robertsdale',
  //   priceSection: priceSection4,
  //   contactNumber: contactNumber,
  //   reviewRating: reviewRating,
  //   reviewLink: reviewLink,
  //   facilityHours: {
  //     officeHrs: {
  //       weekdays: {
  //         open: '0900',
  //         close: '1830',
  //       },
  //       weekends: {
  //         open: '0900',
  //         close: '1200',
  //       },
  //     },
  //     gateHrs: {
  //       weekdays: {
  //         open: '0930',
  //         close: '2000',
  //       },
  //       weekends: {
  //         open: '0900',
  //         close: '1200',
  //       },
  //     },
  //   },
  //   buttonText: buttonText,
  //   facilityGateHours: facilityGateHours,
  // },
];

export const cardDropDown: JumbotronTypes.TCardDropDown = {
  header: {
    data: 'Choose Location',
    icon: {
      iconClassName: 'FaRegBuilding',
      size: '',
      color: 'primary',
    },
  },
  cardInputLabel: 'Location',
};
export const locationMapConfig: LocationTypes.ILocationMap = {
  googleMapAPIKey: 'AIzaSyBNBMPituvbChRZKqK3LSgkNVCANM8X47U',
  height: 750,
  infoWindowmode: 'default',
  locations: exampleLocations,
  showNearbyBusiness: false,
  variant: 'cover-image',
  //   variant: 'cover-image',
  fullWidth: true,
  width: '100%',
  zoomLevel: 15,
  pinIcon: FaMapMarker,
  defaultCoordinates: {
    lat: 42.2520439,
    lng: -73.9077901,
  },
};

export const jumbotronConfig: JumbotronTypes.IJumbotron = {
  variant: 'singleLocation', // | 'singleLocation'| 'singleLocationWithMap' | 'multiLocationListOfCard'| 'multiLocationDropDown'
  contactDetails,
  media,
  textOverlay,
  locationMapConfig,
  cardDropDown,
  accordion,
};
